module.exports = __webpack_public_path__ + "media/5.de808410.wav";